import { z } from 'zod';
/** docs/architecture/08-v1-scope.md § Leads/Notes "attachments" — exactly
 * one parent per attachment, same exclusive-arc convention as Notes/Tasks. */
export const attachmentTargetSchema = z
    .object({
    leadId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
    opportunityId: z.string().uuid().optional(),
    noteId: z.string().uuid().optional(),
})
    .refine((v) => Object.values(v).filter((x) => x !== undefined).length === 1, {
    message: 'Exactly one of leadId/contactId/companyId/opportunityId/noteId is required',
});
export const attachmentResponseSchema = z.object({
    id: z.string().uuid(),
    fileName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int(),
    uploadedBy: z.object({ id: z.string().uuid(), displayName: z.string() }).nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=schemas.js.map